import { useContext } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import AccordionContext from "react-bootstrap/AccordionContext";
import Card from "react-bootstrap/Card";
import { GoChevronRight } from "react-icons/go";

// interface AccordionIconProps {
//   className: string;
// }

// interface AccordionCardProps {
//   title: string;
//   eventKey: string;
//   children: React.ReactNode;
//   headerChildren?: React.ReactNode;
//   icon?: ({ className }: AccordionIconProps) => JSX.Element;
//   handleOnClickToggle?: () => void;
// }

// interface ContextAwareToggleProps {
//   eventKey: string;
//   callback?: () => void;
// }

function ContextAwareToggle({ eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback()
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <button className="btn" type="button" onClick={decoratedOnClick}>
      <GoChevronRight
        className={`${
          isCurrentEventKey ? "rotate-90" : "rotate-0"
        } duration-300 accordion-toggle-go-chevron-right-icon`}
      />
    </button>
  );
}

function AccordionCard({
  title,
  eventKey,
  showByDefault = true,
  children,
  headerChildren,
  icon,
  handleOnClickToggle,
}) {
  if (!title || !eventKey || !children) {
    throw new Error(
      "AccordionCard requires title, eventKey, and children props"
    );
  }

  return (
    <Accordion
      className="accordion-card-container mx-2 mx-md-0"
      defaultActiveKey={showByDefault ? eventKey : null}
    >
      <Card className="border-0">
        <Card.Header className="px-0 mx-0 mx-md-4 border-0 bg-white">
          <div className="row m-auto">
            <div className="col-md-6 d-flex align-items-center">
              <ContextAwareToggle
                eventKey={eventKey}
                callback={handleOnClickToggle}
              />
              {typeof icon === "function" &&
                icon({ className: "accordion-card-icon" })}
              <h3 className="my-0 md:text-3xl">{title}</h3>
            </div>
            {headerChildren && <div className="col-md-6">{headerChildren}</div>}
          </div>
        </Card.Header>

        <Accordion.Collapse eventKey={eventKey}>
          <Card.Body className="pb-4 px-md-5">{children}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default AccordionCard;
